import { cn } from '@/lib/cn';
import { useTypewriter } from '../motion/useTypewriter';

/**
 * La lectura de Atledi sobre un informe: se escribe cuando entra en pantalla,
 * con el cursor de máquina de escribir, y ofrece abrir la conversación. El
 * texto lo compone el motor con las cifras del informe; Atledi no lo inventa.
 */
export function AtlediRead({ kicker, stamp, text, prompt, onOpen, onPrompt, openLabel, className }: {
  kicker: string;
  stamp?: string;
  text: string;
  prompt?: string;
  openLabel: string;
  onOpen?: () => void;
  onPrompt?: () => void;
  className?: string;
}) {
  const tw = useTypewriter(text);
  return (
    <section ref={tw.ref} className={cn('flex flex-col gap-3.5 rounded-[18px] p-[22px]', className)} style={{ background: 'var(--color-dash-night)' }}>
      <div className="flex flex-wrap items-center gap-[11px]">
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full" style={{ background: 'linear-gradient(145deg,#b95cf7,#7b2fd9)' }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" aria-hidden>
            <path d="M15.5 8.5l-2.2 5.3-5.3 2.2 2.2-5.3z" />
            <circle cx="12" cy="12" r="9" />
          </svg>
        </span>
        <span className="text-[19px] font-bold tracking-[-0.01em] text-white">atledi</span>
        <span className="dash-mono text-[10px] font-bold uppercase tracking-[0.12em]" style={{ color: 'var(--color-dash-lime)' }}>{kicker}</span>
        {stamp && (
          <span className="dash-mono ml-auto text-[9px] font-bold uppercase tracking-[0.08em]" style={{ color: 'var(--color-dash-night-fg-subtle)' }}>{stamp}</span>
        )}
      </div>
      <p className="min-h-[120px] max-w-[960px] text-[15px] leading-[1.6] [text-wrap:pretty]" style={{ color: '#dadad4' }}>
        {tw.text}
        {tw.typing && (
          <span className="ml-[3px] inline-block h-[15px] w-2 align-middle" style={{ background: 'var(--color-dash-lime)', animation: 'dash-caret 0.9s steps(1) infinite' }} />
        )}
      </p>
      <div className="flex flex-wrap gap-2.5">
        <button
          type="button"
          onClick={onOpen}
          className="rounded-full px-[15px] py-[9px] text-[13px] font-bold transition-colors hover:brightness-95"
          style={{ background: 'var(--color-dash-lime)', color: 'var(--color-dash-ink)' }}
        >
          {openLabel}
        </button>
        {prompt && (
          <button
            type="button"
            onClick={onPrompt ?? onOpen}
            className="rounded-full border px-[15px] py-[9px] text-[13px] font-semibold transition-colors hover:border-[var(--color-dash-lime)]"
            style={{ borderColor: '#2c2c2c', color: '#edede6' }}
          >
            {prompt}
          </button>
        )}
      </div>
    </section>
  );
}
